"use client"

import {
    SidebarGroup,
    SidebarGroupLabel,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from "@/components/ui/sidebar"

import {
    LayoutDashboard,
    BanknoteArrowUp,
    ListCheck,
    BanknoteArrowDown,
    Fuel,
    Car,
    CarIcon,
    Euro,
    Calendar,
    SquarePercent,
    LayoutList,
    Map,
} from "lucide-react"
import { useTranslate } from "react-admin";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

export function RentalCompanyMenuConfig() {
    const {pathname} = useLocation()

    const navigate = useNavigate();
    const translate = useTranslate();

    const data = {
        dispatch: {
            title: "Activity",
            navs: [
                {
                    name: "Dashboard",
                    url: "/",
                    icon: LayoutDashboard,
                },
                {
                    name: "Gps Track",
                    url: "/gps-track",
                    icon: Map,
                },
                {
                    name: translate(`reservations.name`, { smart_count: 2 }),
                    url: "/rental-orders",
                    icon: Calendar,
                },
                {
                    name: translate(`orders.name`, { smart_count: 2 }),
                    url: "/reservations",
                    icon: LayoutList,
                },
            ]
        },
        management: {
            title: "Management",
            navs: [
                {
                    name: "Partners",
                    url: "/referral-agents",
                    icon: SquarePercent,
                },
                {
                    name: translate(`vehicles.name`, { smart_count: 2 }),
                    url: "/vehicles",
                    icon: Car,
                },
                {
                    name: translate(`vehicle.classes`, { smart_count: 2 }),
                    url: "/vehicle-classes",
                    icon: CarIcon,
                },
                {
                    name: translate(`pricing.name`, { smart_count: 2 }),
                    url: "/rental-pricing",
                    icon: Euro,
                },
                {
                    name: translate(`refueling.name`, { smart_count: 2 }),
                    url: "/refueling",
                    icon: Fuel,
                },
                {
                    name: translate(`expenses.name`, { smart_count: 2 }),
                    url: "/expenses",
                    icon: BanknoteArrowDown,
                },
                {
                    name: translate(`services.name`, { smart_count: 2 }),
                    url: "/service",
                    icon: ListCheck,
                },
                {
                    name: translate(`incomes.name`, { smart_count: 2 }),
                    url: "/incomings",
                    icon: BanknoteArrowUp,
                },
            ]
        }
    }

    return (
        <SidebarGroup>
            <SidebarGroupLabel>{data.dispatch.title}</SidebarGroupLabel>
            <SidebarMenu>
                {data.dispatch.navs.map((item: any) => (
                    <SidebarMenuItem key={item.name} className={`${item.url == "" + pathname ? 'bg-gray-200 dark:bg-neutral-600 rounded-lg' : ''}`}>
                        <SidebarMenuButton asChild>
                            <NavLink to={item.url}>
                                <item.icon />
                                <span>{item.name}</span>
                            </NavLink>
                        </SidebarMenuButton>

                    </SidebarMenuItem>
                ))}
            </SidebarMenu>
            <SidebarGroupLabel className="mt-4">{data.management.title}</SidebarGroupLabel>
            <SidebarMenu>
                {data.management.navs.map((item: any) => (
                    <SidebarMenuItem key={item.name} className={`${item.url == "" + pathname ? 'bg-gray-200 dark:bg-neutral-600 rounded-lg' : ''}`}>
                        <SidebarMenuButton asChild>
                            <NavLink to={item.url}>
                                <item.icon />
                                <span>{item.name}</span>
                            </NavLink>
                        </SidebarMenuButton>

                    </SidebarMenuItem>
                ))}
            </SidebarMenu>
        </SidebarGroup>
    )
}
